import { For } from "solid-js";

/** Row skeletons for the message list (deferred-reveal handled globally). */
export function MessageListSkeleton() {
  return (
    <div class="flex flex-col divide-y divide-border/20" data-testid="mail-list-skeleton">
      <For each={Array.from({ length: 8 })}>
        {() => (
          <div class="flex items-start gap-3 px-4 py-3">
            <div class="mt-0.5 h-4 w-4 shrink-0 rounded bg-muted animate-pulse" />
            <div class="min-w-0 flex-1 space-y-2">
              <div class="h-3 w-1/3 rounded bg-muted animate-pulse" />
              <div class="h-3 w-2/3 rounded bg-muted animate-pulse" />
              <div class="h-2.5 w-1/2 rounded bg-muted/70 animate-pulse" />
            </div>
          </div>
        )}
      </For>
    </div>
  );
}

/** Reader panel skeleton. */
export function ReaderSkeleton() {
  return (
    <div class="space-y-4 p-6" data-testid="mail-reader-skeleton">
      <div class="h-6 w-2/3 rounded bg-muted animate-pulse" />
      <div class="h-4 w-1/3 rounded bg-muted animate-pulse" />
      <div class="space-y-2 pt-4">
        <For each={Array.from({ length: 6 })}>
          {() => <div class="h-3 w-full rounded bg-muted/70 animate-pulse" />}
        </For>
      </div>
    </div>
  );
}
